export default __webpack_public_path__ + "static/assets/fonts/c78c809aedd8bc98497b36895eebdc52.ttf";